import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link, useNavigate } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../Pages/Config";
import { CountdownTimer } from "./CountDownTimer";
import { FaTrash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import { formatDate } from "../components/dateUtils";

export default function SettingUnsold() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setToastMessage] = useState("");
  const [BidCount, setBidCount] = useState({});

  const fetchBidCounts = async (productIds) => {
    try {
      const response = await axios.post(`${BASE_URL}/bid_count.php`, {
        ids: productIds,
      });

      console.log("bidders", response);
      if (response.data.success) {
        setBidCount(response.data.data);
      } else {
        console.error("Bid count fetch failed");
      }
    } catch (error) {
      console.error("Error fetching bid counts:", error);
    }
  };

  useEffect(() => {
    if (products.length > 0) {
      const ids = products.map((p) => p.id);
      fetchBidCounts(ids);
    }
  }, [products]);

  const fetchProducts = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/all_selling_user_unsold_item.php?id=${userId}&t=${Date.now()}`
      );

      console.log(response);
      if (response.data.success && Array.isArray(response.data.data)) {
        setProducts(response.data.data);
        console.log("unsold", response.data.data);
      } else {
        console.error("Unexpected API structure");
        setProducts([]);
      }
    } catch (error) {
      console.error("Failed to fetch products", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const deleteproduct = async (productId: number) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/delete_item.php?id=${productId}`
      );

      if (response.data.success) {
        // setToastMessage("Product deleted successfully.");
        toast.success("Product deleted successfully.");
        fetchProducts();
      } else {
        // alert("Failed to delete product.");
        toast.warning("Failed to delete product.");
        fetchProducts();
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error(
        "An error occurred while deleting the product. Try again later."
      );
    }
  };

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>
                <p>UNSOLD</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  {loading ? (
                    <b>Loading...</b>
                  ) : (
                    <b>
                      Unsold {products.length}{" "}
                      {products.length < 1 ? "Item" : "Items"}{" "}
                    </b>
                  )}
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      className="loading-overlay"
                      style={{
                        height: "550px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div className="dot-spinner__dot" key={i}></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product, index) => (
                      <div
                        key={index}
                        className="col-xl-4 col-lg-4 col-md-6 p-0 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <div className="card-img">
                              <img
                                src={
                                  product.photo
                                    ? `${BASE_URL}/${product.photo
                                        .split(",")[0]
                                        .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt=""
                              />
                            </div>
                            <ul
                              className="view-and-favorite-area"
                              style={{ opacity: "15" }}
                            >
                              <li>
                                <span
                                  onClick={() => {
                                    const confirmDelete = window.confirm(
                                      "Are you sure you want to delete this product?"
                                    );
                                    if (confirmDelete)
                                      deleteproduct(product.id);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    background: "white",
                                    padding: "10px 12px",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <FaTrash style={{ color: "#F3DA7B" }} />
                                </span>
                              </li>
                              {/* <li
                                style={{ marginTop: "25px", marginLeft: "5px" }}
                              >
                                <Link to={`/list-an-item-edit/${product.id}`}>
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      background: "white",
                                      padding: "10px 12px",
                                      borderRadius: "50%",
                                    }}
                                  >
                                    <FaEdit style={{ color: "blue" }} />
                                  </span>
                                </Link>
                              </li> */}
                            </ul>
                            <CountdownTimer
                              closingTime={product.closing_time}
                            />
                          </div>

                          <div className="auction-card-content">
                            <p style={{ fontSize: "12px" }}>
                              {formatDate(product.closing_time)}
                            </p>
                            <h6>
                              <Link to="">{product.title}</Link>
                            </h6>

                            <div className="details_buyer">
                              <h6>Item Id</h6>
                              <p style={{ fontWeight: "800" }}>#{product.id}</p>
                            </div>

                            <div className="details_buyer">
                              <h6>Bidders</h6>
                              <p style={{ fontWeight: "800" }}>
                                {BidCount[product.id] || 0}
                              </p>
                            </div>
                            <div className="details_buyer">
                              <h6>Top Bid</h6>
                              <p
                                style={{ color: "#ebc32f", fontWeight: "800" }}
                              >
                                {product.current_price} SAR
                              </p>
                            </div>

                            <div className="rate_btn">
                              <Link to={`/list-an-item-edit/${product.id}`}>
                                <button>Relist Item Again ? </button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}

      <Fotter />
    </>
  );
}
